import {camelCase} from 'lodash'
import {Context} from '@/project'
import {TransformerResponse} from '@/lib/axiosAddTransforms'
import objectTransformer from '@/lib/objectTransformer'

const dataKey: TransformerResponse<Context> = (data) => {
  if(!data) {
    return data
  }
  return objectTransformer(data, camelCase, true)
}

export default dataKey
